(function () {
	angular
		.module('trackeye')
		.factory('EventIconMeta', EventIconMeta);

	EventIconMeta.$inject = [];

	function EventIconMeta() {
		var exports = {};
		
		exports.getMeta = function(message, nextMessage, device) {
			var className = "",
				prefix = "c4a",
				addition = false,
				feat = device.features;

			if (feat.isCapture()) {
				if (message.isByTurnSignal()) {
					className = "turn-signal";
					addition = message.isByMoving() ? "movement-indicator" : false;
				} else if (message.isByBrake()) {
					className = "brake";
					addition = message.isByMoving() ? "movement-indicator" : false;
				} else if (message.isByHeadlight()) {
					className = "headlight";
					addition = message.isByMoving() ? "movement-indicator" : false;
				}
			} else if (feat.isPower()) {
				className = "engine"
				if (message.isByActive() || (
					// Power UAP error work around
					device.getApplication() >= 19 &&
					message.isStatemaskBitSet(16)) 
				) {
					className += " active"
				} else if (message.isByMoving()) {
					className += " moving"
				} else {
					className += " cyclic"
				}

				if (message.isByInput2High()) {
					addition = "wrench"
				}
			} else {
				if (message.isByAlarm1()) {
					className = "lightning";
				} else if (message.isByTamper() && feat.hasTamper()) {
					className = "tamper";
				} else if (message.isByAlarm2()) {
					className = "lightning-move";
				} else if (message.isByEchoHeard()) {
					className = "echotag-heard";
				} else if (message.isByEchoLost()) {
					className = "echotag-lost"
				} else if (message.isByLight() && feat.hasLightSensor()) {
					className = "light";
				} else if (message.isBeaconActive() && feat.hasBeacon()) {
					className = "rf-beacon";
				} else if (message.isByCustomTime()) {
					className = "hours";
				} else if (message.isByMoving()) {
					className = "movement";
				} else if (nextMessage && !message.isByMoving() && nextMessage.isByMoving()) {
					className = "no-movement";
				} else {
					className = "hourglass";
				}
			}

			var meta = {
				prefix: prefix,
				class: className,
				addition: addition,
				title: "STR_ACTIVE_EVENT_" + className.replace(" ", "_").replace("-", "_").toUpperCase(),
				title_addition: addition ? "STR_ACTIVE_EVENT_MOVEMENT" : undefined
			};

			if (feat.isPower()) {
				meta.title_addition = addition ? "STR_ACTIVE_EVENT_AUX" : undefined 
			} else {
				meta.title_addition = addition ? "STR_ACTIVE_EVENT_MOVEMENT" : undefined
			}
			return meta
		}
		return exports
	}
})();